import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

import {
  CONFIRM_USER_PHONE,
  SEND_RESET_PIN,
  CHECK_RESET_PASSWORD_PIN
} from "../gql/AuthQueries";

export default {
  name: "confirmation_phone",

  data() {
    return {
      code: "",
      isTokenInvalid: true,
      submitLoading: false,
      isFinishedTimer: false,
      isSubmitCode: false,
      checkPin: true
    };
  },

  validations() {
    let params = {
      code: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      }
    };

    return params;
  },

  props: {
    type: {
      type: String,
      default: "sing_up"
    },

    isBuyerRegistration: {
      type: Boolean,
      default: false
    }
  },

  apollo: {
    getUser: {
      query: CHECK_RESET_PASSWORD_PIN,

      variables() {
        return {
          phone: localStorage.getItem("signupPhone"),
          resetPasswordPin: this.code
        };
      },

      skip() {
        return this.checkPin;
      },

      result({
        data: {
          checkResetPasswordPin: { isExist }
        }
      }) {
        this.checkPin = true;

        if (isExist) {
          this.$router.push({
            name: "reset_password",
            params: { reset_password_pin: this.code }
          });
        }
      },

      error(mutationError) {
        this.checkPin = true;

        const errors = mutationError.graphQLErrors;

        for (let error in errors) {
          this.$toasted.error(errors[error].message);
        }
      }
    }
  },

  watch: {
    code: function(newV) {
      if (newV.length === 6) {
        switch (this.type) {
          case "sing_up":
            this.submitCode();
            break;
          case "reset_password":
            this.goToResetPassword();
            break;

          default:
            this.submitCode();
            break;
        }
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("signupPhone")) {
      next();
    } else {
      next({ name: "home" });
    }
  },

  methods: {
    finishedTimer() {
      this.isFinishedTimer = true;
    },

    goToResetPassword() {
      this.checkPin = false;
    },

    submitCode() {
      this.isSubmitCode = true;

      this.$apollo
        .mutate({
          mutation: CONFIRM_USER_PHONE,
          variables: {
            phone: localStorage.getItem("signupPhone"),
            pin: this.code
          }
        })
        .then(({ data: { confirmUserPhone: { user, accessToken } } }) => {
          if (typeof localStorage !== "undefined" && accessToken) {
            localStorage.setItem("AUTH_TOKEN", accessToken);
          }

          localStorage.removeItem("signupPhone");

          this.$emit("userLoggedIn");
          this.$store.commit("setUserInfo", user);

          if (user.role == "buyer") {
            if (this.isBuyerRegistration) {
              this.$emit("goToPersonalizeSlide");
            } else {
              this.$router.push({
                name: "personalize"
              });
            }
          } else {
            this.$router.push({
              name: "identity_documents"
            });
          }
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.isSubmitCode = false;
        });
    },

    resendPhonePin() {
      this.submitLoading = true;

      this.$apollo
        .mutate({
          mutation: SEND_RESET_PIN,
          variables: {
            phone: localStorage.getItem("signupPhone")
          }
        })
        .then(() => {
          this.code = "";
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitLoading = false;

          this.$refs.vac.startCountdown(true);
          this.isFinishedTimer = false;
        });
    }
  },

  components: {
    LoadingIcon
  }
};
